import { render, staticRenderFns } from "./DisplayPicture.vue?vue&type=template&id=0de542e4&scoped=true&"
import script from "./DisplayPicture.vue?vue&type=script&lang=js&"
export * from "./DisplayPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de542e4",
  null
  
)

export default component.exports